import { BookOpenText, Mic2, Newspaper, Radio, Users, Compass, HeartHandshake, Feather } from "lucide-react";

// Facts-based "parcours" timeline — credibility through visible realities, no adjectives.
const STEPS = [
  { Icon: BookOpenText, t: "Une bibliographie", d: "Plusieurs ouvrages publiés, de l'ésotérisme au deuil, de la poésie à la fiction." },
  { Icon: Feather, t: "Une écriture", d: "Un univers éditorial cohérent, construit au fil des années." },
  { Icon: Mic2, t: "Des conférences", d: "Salons, rencontres et interventions publiques sur l'histoire de l'invisible." },
  { Icon: Newspaper, t: "Presse", d: "Des articles et des publications autour de son travail." },
  { Icon: Radio, t: "Radio & médias", d: "Interviews et passages médiatiques." },
  { Icon: Users, t: "Une communauté", d: "Un public fidèle qui suit ses contenus sur plusieurs réseaux." },
  { Icon: Compass, t: "Les Chroniques de l'Étrange", d: "Un projet éditorial dédié à l'histoire de l'étrange." },
  { Icon: HeartHandshake, t: "AAESAD", d: "Une association d'aide et de soutien au deuil." },
];

export default function Timeline() {
  return (
    <section className="dl-container py-16 md:py-24" data-testid="timeline-section">
      <div className="mb-12">
        <div className="dl-eyebrow mb-3">Un parcours</div>
        <h2 className="serif text-4xl md:text-5xl text-[#F3E9D2]">Des livres, des scènes, des projets</h2>
        <p className="text-[#F3E9D2]/65 mt-4 max-w-2xl">
          Une trajectoire faite de livres, de conférences, de transmission et de projets qui se répondent.
        </p>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
        {STEPS.map(({ Icon, t, d }, i) => (
          <div key={i} className="dl-card p-6 relative">
            <span className="absolute top-4 right-5 serif text-3xl text-[#C6A76A]/25">0{i + 1}</span>
            <Icon size={22} className="text-[#C6A76A] mb-4" />
            <h3 className="serif text-xl text-[#F3E9D2]">{t}</h3>
            <p className="text-sm text-[#F3E9D2]/60 mt-2 leading-relaxed">{d}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
